exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feature-wrapper[data-v-3357a7d7]{cursor:pointer;align-items:center;justify-items:center;color:#7e8da7;font-size:14px;gap:12px;display:flex;padding:2px 8px;margin-left:5px;position:relative;width:fit-content}.feature-wrapper[data-v-3357a7d7]:active{color:var(--darkBlue)}.feature-new[data-v-3357a7d7]{position:absolute;right:-32px;padding:1px 4px;background:#1b59f8;border-radius:8px;font-size:9px;font-weight:600;color:#fff}.feature-icon[data-v-3357a7d7]{width:22px;height:22px}.feature-wrapper[data-v-3357a7d7]:hover{color:var(--activeHoverSidebar)}.feature-name[data-v-3357a7d7]{max-width:15ch}.feature-notification[data-v-3357a7d7]{width:6px;height:6px;position:absolute;right:0;top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3357a7d7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/components/leftMenuFeatures.vue
// module id = 844
// module chunks = 0